import BaseComponent from 'scripts/BaseComponent.js';
import UnderlayHelper from '../../global/underlay-helper';
import { AccessibilityHelper } from '../../../scripts/accessibility/accessibilityHelper';

export default class ImageZoomModal extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      zoomImageWrap: '.js-zoomImageWrap',
      zoomImage: '.js-zoomImage',
      zoomModalClose: '.js-zoomModalClose',
    };

    this.dom = {
      $component: component,
      $zoomImageWrap: this.$get(this.refs.zoomImageWrap),
      $zoomImage: this.$get(this.refs.zoomImage),
      $zoomModalClose: this.$get(this.refs.zoomModalClose),
    };

    this.state = {
      updateZoomImageEvent: 'updatezoomimage',
      activeClass: 'is-active',
      showClass: 'show',
      isVariantImageClass: 'is-variant-image',
      underlayHelper: new UnderlayHelper({ overNav: true }),
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
      animationDuration: 500,
    };

    this.mount();
  }

  mount() {
    const { dom, state } = this;
    super.mount();

    this.setOnCustomEvent(state.updateZoomImageEvent, this.updateZoomImage);
    this.setClick(dom.$zoomModalClose, this.closeModal);
    this.setOnEscapeKey(this.closeModal);
    state.underlayHelper.addClickListener(this.closeModal.bind(this));
    state.focusTrap = state.accessibilityHelper.buildFocusTrap([dom.$component]);
  }

  updateZoomImage({ detail: { imageSrc, imageSrcsets, variantImage } }) {
    const { dom, state } = this;

    this.loadImage(imageSrc);

    imageSrcsets.split('|').forEach((srcsetString) => {
      const [media, srcset] = srcsetString.split('*');
      dom.$zoomImageWrap.querySelector(`source[media="${media}"]`).srcset = srcset;
    });

    if (variantImage) {
      dom.$zoomImage.classList.add(state.isVariantImageClass);
    } else {
      dom.$zoomImage.classList.remove(state.isVariantImageClass);
    }
  }

  loadImage(imageSrc) {
    const { dom } = this;
    const image = new Image();

    image.src = imageSrc;
    image.addEventListener('load', () => {
      dom.$zoomImage.src = imageSrc;
      this.openModal();
    });
  }

  openModal() {
    const { dom, state } = this;

    dom.$component.classList.add(state.activeClass);
    setTimeout(() => {
      dom.$component.classList.add(state.showClass);
    }, 0);

    dom.$component.setAttribute('aria-hidden', 'false');
    dom.$component.setAttribute('aria-expanded', 'true');
    state.underlayHelper.open();
    state.focusTrap.set();
  }

  closeModal() {
    const { dom, state } = this;

    dom.$component.classList.remove(state.showClass);
    setTimeout(() => {
      dom.$component.classList.remove(state.activeClass);
    }, state.animationDuration);

    dom.$component.setAttribute('aria-hidden', 'true');
    dom.$component.setAttribute('aria-expanded', 'false');
    state.underlayHelper.close();
    state.focusTrap.unset();
  }
}
